import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const Icons = {
  Overview: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" />
      <rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" />
    </svg>
  ),
  Users: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  Consumers: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 21a6 6 0 0 0-6-6H6a6 6 0 0 0-6 6v3h24v-3a6 6 0 0 0-6-6zM15 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
    </svg>
  ),
  Businesses: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  ),
  Categories: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
    </svg>
  ),
  Moderation: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  ),
  Settings: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  ),
  Collapse: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="15 18 9 12 15 6" />
    </svg>
  ),
  Expand: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6" />
    </svg>
  ),
  Globe: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  ),
  Logout: (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" />
    </svg>
  ),
};

const menuItems = [
  { id: 'dashboard', label: 'Overview', icon: 'Overview', path: '/admin/dashboard', badge: null },
  // { id: 'users', label: 'Users', icon: 'Users', path: '/admin/users', badge: null },
  { id: 'consumers', label: 'Consumers', icon: 'Consumers', path: '/admin/consumers', badge: null },
  { id: 'businesses', label: 'Businesses', icon: 'Businesses', path: '/admin/businesses', badge: null },
  { id: 'categories', label: 'Categories', icon: 'Categories', path: '/admin/categories', badge: null },
  // { id: 'moderation', label: 'Moderation', icon: 'Moderation', path: '/admin/moderation', badge: '2' },
  // { id: 'settings', label: 'Settings', icon: 'Settings', path: '/admin/settings', badge: null },
];

const AdminSidebar = ({ onLogout }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const initial = user?.name?.charAt(0).toUpperCase() ?? 'A';

  const isActive = (path) => location.pathname === path;

  return (
    <aside
      style={{ transition: 'width 280ms cubic-bezier(0.4,0,0.2,1)' }}
      className={`fixed left-0 top-0 h-screen z-50 flex flex-col overflow-hidden
        bg-[#1b2b4b] border-r border-white/[0.06]
        ${isCollapsed ? 'w-[72px]' : 'w-[240px]'}`}
    >
      {/* ── Brand header ── */}
      <div className="flex items-center justify-between px-4 h-16 border-b border-white/[0.06] shrink-0">
        <div
          className="flex items-center gap-3 overflow-hidden"
          style={{ opacity: isCollapsed ? 0 : 1, transition: 'opacity 200ms', width: isCollapsed ? 0 : 'auto' }}
        >
          <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-blue-500 text-white font-bold text-sm">V</div>
          <span className="text-[13px] font-semibold text-white tracking-tight whitespace-nowrap">VMC Admin</span>
        </div>
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-slate-400 hover:text-white hover:bg-white/[0.07] transition-colors"
          title={isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {isCollapsed ? Icons.Expand : Icons.Collapse}
        </button>
      </div>

      {/* ── User pill ── */}
      <div className={`flex items-center gap-3 mx-3 mt-4 mb-2 rounded-lg p-2.5 bg-white/[0.04] border border-white/[0.05] shrink-0 overflow-hidden ${isCollapsed ? 'justify-center' : ''}`}>
        <div className="h-8 w-8 shrink-0 rounded-full bg-gradient-to-br from-blue-400 to-violet-500 flex items-center justify-center text-xs font-bold text-white">
          {initial}
        </div>
        {!isCollapsed && (
          <div className="overflow-hidden">
            <p className="text-[12.5px] font-semibold text-white truncate leading-tight">{user?.name}</p>
            <p className="text-[11px] text-slate-500 leading-tight">Administrator</p>
          </div>
        )}
      </div>

      {/* ── Nav section label ── */}
      {!isCollapsed && (
        <p className="px-5 pt-4 pb-1.5 text-[10.5px] font-semibold uppercase tracking-widest text-slate-600 shrink-0">
          Menu
        </p>
      )}

      {/* ── Navigation ── */}
      <nav className="flex-1 overflow-y-auto overflow-x-hidden px-3 pb-2 space-y-0.5">
        {menuItems.map((item) => {
          const active = isActive(item.path);
          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              title={isCollapsed ? item.label : undefined}
              className={`group relative w-full flex items-center rounded-lg
                ${isCollapsed ? 'justify-center px-0 py-2.5' : 'gap-3 px-3 py-2.5'}
                text-left transition-colors duration-150
                ${active
                  ? 'bg-blue-600/20 text-blue-400'
                  : 'text-slate-400 hover:text-slate-100 hover:bg-white/[0.05]'
                }`}
            >
              {/* Active left bar */}
              {active && (
                <span className="absolute left-0 top-1/2 -translate-y-1/2 h-5 w-[3px] rounded-r-full bg-blue-500" />
              )}

              {/* Icon */}
              <span className={`shrink-0 ${active ? 'text-blue-400' : 'text-slate-500 group-hover:text-slate-300'} transition-colors`}>
                {Icons[item.icon]}
              </span>

              {/* Label + badge */}
              {!isCollapsed && (
                <span className="flex flex-1 items-center justify-between overflow-hidden">
                  <span className={`text-[13px] font-medium truncate ${active ? 'text-blue-300' : ''}`}>
                    {item.label}
                  </span>
                  {item.badge && (
                    <span className="ml-2 flex h-4.5 min-w-[18px] items-center justify-center rounded-full bg-red-500/20 px-1.5 text-[10px] font-semibold text-red-400">
                      {item.badge}
                    </span>
                  )}
                </span>
              )}

              {/* Collapsed tooltip */}
              {isCollapsed && (
                <span className="pointer-events-none absolute left-[calc(100%+10px)] z-50 hidden group-hover:flex
                  whitespace-nowrap rounded-md bg-slate-800 border border-white/[0.08] px-2.5 py-1.5
                  text-[12px] font-medium text-slate-100 shadow-xl">
                  {item.label}
                  {item.badge && (
                    <span className="ml-1.5 rounded-full bg-red-500/30 px-1 text-[10px] text-red-400">{item.badge}</span>
                  )}
                </span>
              )}
            </button>
          );
        })}
      </nav>

      {/* ── Bottom actions ── */}
      <div className={`shrink-0 border-t border-white/[0.06] p-3 ${isCollapsed ? 'space-y-1.5' : 'space-y-1.5'}`}>
        <a
          href="/"
          title={isCollapsed ? 'View Website' : undefined}
          className={`group flex items-center rounded-lg text-slate-400 hover:text-slate-100 hover:bg-white/[0.05] transition-colors
            ${isCollapsed ? 'justify-center py-2.5 px-0' : 'gap-3 px-3 py-2.5'}`}
        >
          <span className="shrink-0 text-slate-500 group-hover:text-slate-300 transition-colors">{Icons.Globe}</span>
          {!isCollapsed && <span className="text-[13px] font-medium">View Website</span>}
        </a>
        <button
          onClick={onLogout}
          title={isCollapsed ? 'Logout' : undefined}
          className={`group flex w-full items-center rounded-lg text-slate-400 hover:text-red-400 hover:bg-red-500/[0.08] transition-colors
            ${isCollapsed ? 'justify-center py-2.5 px-0' : 'gap-3 px-3 py-2.5'}`}
        >
          <span className="shrink-0 text-slate-500 group-hover:text-red-400 transition-colors">{Icons.Logout}</span>
          {!isCollapsed && <span className="text-[13px] font-medium">Logout</span>}
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;
